import { DelayValues } from "@omni/types/components/props/shared/delay.values";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { progressBar } from "./progressBar.variants";

export type BarComponentProps = {
    isRunning: boolean;
    isActiveIndex: boolean;
    isStopped: boolean;
    isInitial: boolean;
    stopTimer: () => void;
    slideTo: (index: number) => void;
    index: number;
    delay: DelayValues;
};

const BarComponent = ({
    isRunning,
    isActiveIndex,
    isStopped,
    isInitial,
    stopTimer,
    slideTo,
    index,
    delay
}: BarComponentProps) => {
    return (
        <Button
            size="sm"
            color="transparent"
            className={cn(
                "tw:group tw:p-0 tw:h-3.5! tw:transition-all tw:duration-300 tw:rounded-full tw:focus:rounded-full! tw:hover:rounded-full!",
                "tw:hover:ring-3 tw:hover:ring-primary/50! tw:hover:border-none!",
                "tw:focus:ring-primary/50! tw:focus:border-none!",
                {
                    "tw:w-14": isRunning && isActiveIndex,
                    "tw:w-3.5": !isActiveIndex || isStopped || isInitial
                }
            )}
            onClick={() => {
                stopTimer();
                slideTo(index);
            }}
        >
            <div
                className={progressBar({
                    delay: `${delay}`,
                    rounded: true,
                    isRunning: isRunning && isActiveIndex,
                    isStopped: isStopped || isInitial,
                    isActive: isActiveIndex && !isInitial,
                    className: cn("tw:animation-delay-[300ms]")
                })}
            ></div>
        </Button>
    );
};

export { BarComponent };
